import { createSlice } from "@reduxjs/toolkit";

const initialState: {
  timeDifference: number;
  allowTime: number;
} = {
  timeDifference: 0,
  allowTime: 0,
};

const settings = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setTimeDifference: (state, action) => {
      state.timeDifference = action.payload;
    },
    setHMACAllowTime: (state, action) => {
      state.allowTime = action.payload;
    },
  },
});

export const { setTimeDifference, setHMACAllowTime } = settings.actions;

export default settings;
